import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import DynamicTabwiseTable from "../../../components/dynamicscreens/DynamicTabwiseTable";
import { withRouter } from "../../../components/withRouter";
import {
    changeActive,
    noInternetMsg,
    serverMsg,
    statusFailedMsg,
    statusmsg
} from "../../../config/messageconstant";
import { OutletProspectiveStatusJson } from "../../../DynamicFormsJson/MastersJSON/outletProspectiveStatus";
import { getAreaByTaluka, getAreaByUserType } from "../../../Slice/area.slice";
import { getBeatByAreaIds } from "../../../Slice/beat.slice";
import { getDistrictByZone } from "../../../Slice/district.slice";
import { getOutletByBeatIdsProspectiveStatus, setOutletByBeatIds } from "../../../Slice/outlet.slice";
import { getRegionNew } from "../../../Slice/region.slice";
import { getStateByRegion } from "../../../Slice/state.slice";
import { getTalukaByDistrict } from "../../../Slice/taluka.slice";
import { getZoneByState } from "../../../Slice/zone.slice";
import { OutletStatusColumns } from "../../../tableColumns/table-columns";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { apiPost } from "../../../utils/api_service";
import endpoint from "../../../config/endpoints";

class OutletStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabValue: 1,
            filterData: {},
            dynamicMasterData: {
                regionDetail: this.props.regionList?.region,
                stateDetail: this.props.stateList?.stateByRegion,
                zoneDetail: this.props.zoneList?.zoneByState,
                districtDetail: this.props.districtList?.districtByZone,
                talukaDetail: this.props.talukaList?.talukaByDistrict,
                areaDetail: this.props.areaList?.areaByTaluka,
                areaDetail: this.props.areaList?.area,

                outletProspective:
                    this.props.outletList?.outlets.filter(
                        (row) => row.isProspective == 1 && row.isActive == 1
                    ),
                outletCoverage:
                    this.props.outletList?.outlets.filter(
                        (row) => row.isProspective == 0 && row.isActive == 1
                    ),
                outletInactive:
                    this.props.outletList?.outlets.filter(
                        (row) => row.isActive == 0
                    ),
            },
            tabList: [
                {
                    label: "Prospective",
                    allyProps: 0,
                    columns: OutletStatusColumns,
                    showExcelDownload: false,
                    isActionColActive: false,
                    value: "outletProspective",
                    searchList: OutletProspectiveStatusJson.searchList,
                },
                {
                    label: "Coverage",
                    allyProps: 1,
                    columns: OutletStatusColumns,
                    isActionColActive: false,
                    showExcelDownload: false,
                    value: "outletCoverage",
                    searchList: OutletProspectiveStatusJson.searchList,
                },
                {
                    label: "Inactive",
                    allyProps: 2,
                    columns: OutletStatusColumns,
                    isActionColActive: false,
                    showExcelDownload: false,
                    value: "outletInactive",
                    searchList: OutletProspectiveStatusJson.searchList,
                },
            ],
        };
    }
    componentDidMount() {
        this.getListData();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.regionList !== nextProps.regionList) {
            if (this.props.regionList?.region !== nextProps.regionList?.region) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        regionDetail: nextProps.regionList?.region,
                    },
                });
            }
        }
        if (this.props.stateList !== nextProps.stateList) {
            if (
                this.props.stateList?.stateByRegion !==
                nextProps.stateList?.stateByRegion
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        stateDetail: nextProps.stateList?.stateByRegion,
                    },
                });
            }
        }
        if (this.props.zoneList !== nextProps.zoneList) {
            if (
                this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        zoneDetail: nextProps.zoneList?.zoneByState,
                    },
                });
            }
        }
        if (this.props.districtList !== nextProps.districtList) {
            if (
                this.props.districtList?.districtByZone !==
                nextProps.districtList?.districtByZone
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        districtDetail: nextProps.districtList?.districtByZone,
                    },
                });
            }
        }
        if (this.props.talukaList !== nextProps.talukaList) {
            if (
                this.props.talukaList?.talukaByDistrict !==
                nextProps.talukaList?.talukaByDistrict
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        talukaDetail: nextProps.talukaList?.talukaByDistrict,
                    },
                });
            }
        }
        if (this.props.areaList !== nextProps.areaList) {
            if (
                this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        areaDetail: nextProps.areaList?.areaByTaluka,
                    },
                });
            }
        }

        if (this.props.areaList !== nextProps.areaList) {
            if (
                this.props.areaList?.area !== nextProps.areaList?.area
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        areaDetail: nextProps.areaList?.area,
                    },
                });
            }
        }
        if (this.props.beatList !== nextProps.beatList) {
            if (this.props.beatList?.beat !== nextProps.beatList?.beat) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        beatDetail: nextProps.beatList?.beat,
                    },
                });
            }
        }
        if (this.props.beatList !== nextProps.beatList) {
            if (
                this.props.beatList?.beatByUserType !==
                nextProps.beatList?.beatByUserType
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        beatDetail: nextProps.beatList?.beatByUserType,
                    },
                });
            }
        }

        if (this.props.outletList !== nextProps.outletList) {
            if (
                this.props.outletList?.outlets !==
                nextProps.outletList?.outlets
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,

                        outletProspective:
                            nextProps.outletList?.outlets
                                .filter((row) => row.isProspective == 1 && row.isActive == 1)
                                .map((rowData, index) => {
                                    return { ...rowData, index: index + 1 };
                                }),

                        outletCoverage:
                            nextProps.outletList?.outlets
                                .filter((row) => row.isProspective == 0 && row.isActive == 1)
                                .map((rowData, index) => {
                                    return { ...rowData, index: index + 1 };
                                }),

                        outletInactive:
                            nextProps.outletList?.outlets
                                .filter((row) => row.isActive == 0)
                                .map((rowData, index) => {
                                    return { ...rowData, index: index + 1 };
                                }),
                    },
                });
            }
        }
    }

    onSearchData = async (data) => {
        const { getOutletByBeatIdsProspectiveStatus, showLoador, showNotification } = this.props;

        this.setState({ filterData: data });

        if (navigator.onLine) {
            let outletByBeatIdsJson = {
                beatIds: data.beat
            }
            showLoador({ loador: true });
            await getOutletByBeatIdsProspectiveStatus({ beatIds: outletByBeatIdsJson }).then(({ success }) => {
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    getListById = async (data) => {
        const {
            getStateByRegion,
            getZoneByState,
            getDistrictByZone,
            getTalukaByDistrict,
            getAreaByTaluka,
            showLoador,
            showNotification,
            getBeatByAreaIds,
        } = this.props;
        if (navigator.onLine) {
            if (data.region && data.region != "") {
                showLoador({ loador: true });
                await getStateByRegion({ regionIds: data.region }).then(
                    ({ success }) => {
                        showLoador({ loador: false });
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        }
                    }
                );
            }
            if (data.state && data.state != "") {
                showLoador({ loador: true });
                await getZoneByState({ stateIds: data.state }).then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
            }
            if (data.zone && data.zone != "") {
                showLoador({ loador: true });
                await getDistrictByZone({ zoneIds: data.zone }).then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
            }
            if (data.district && data.district != "") {
                showLoador({ loador: true });
                await getTalukaByDistrict({ districtIds: data.district }).then(
                    ({ success }) => {
                        showLoador({ loador: false });
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        }
                    }
                );
            }
            if (data.taluka && data.taluka != "") {
                showLoador({ loador: true });
                await getAreaByTaluka({ talukaIds: data.taluka }).then(
                    ({ success }) => {
                        showLoador({ loador: false });
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        }
                    }
                );
            }
            if (data.areaIds && data.areaIds != "") {
                let outletJson = {
                    areaIds: data.areaIds,
                }
                showLoador({ loador: true });
                await getBeatByAreaIds({ areaIdsJson: outletJson }).then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
            }
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    getListData = async () => {
        const { getRegionNew, getAreaByUserType, setOutletByBeatIds, showLoador, showNotification } =
            this.props;
        const { tabList } = this.state;
        if (navigator.onLine) {

            console.log(tabList);

            setOutletByBeatIds({ row: [] });

            if (localStorage.getItem("userTypeId") &&
                localStorage.getItem("userTypeId") == 3) {

                this.setState((prevState) => ({
                    tabList: prevState.tabList.map((tab) => ({
                        ...tab,
                        searchList: OutletProspectiveStatusJson.searchListForManager,
                    })),
                }));

                showLoador({ loador: true });
                await getAreaByUserType().then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });

            } else {
                showLoador({ loador: true });
                await getRegionNew().then(({ success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });

            }
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };



    onChangeStatus = (rowData) => {
        const { showLoador, showNotification } = this.props;
        const { filterData } = this.state;

        let status = rowData.isActive == 1 ? 0 : 1;
        let remark = "";

        if (navigator.onLine) {
            swal({
                title: "Are you sure?",
                text: changeActive,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    apiPost({
                        url:
                            endpoint.outlet +
                            "/update-is-active?id=" +
                            rowData.id +
                            "&isActive=" +
                            status +
                            "&remark=" +
                            remark,
                    }).then(({ data, success }) => {
                        showLoador({ loador: false });
                        if (success) {
                            showNotification({ msg: statusmsg });
                            this.onSearchData(filterData)
                        } else {
                            showNotification({ msg: statusFailedMsg, severity: "error" });
                        }
                    });
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    render() {
        const { outletList } = this.props;
        const { dynamicMasterData, tabList } = this.state;
        return (
            <>
                <DynamicTabwiseTable
                    dynamicMasterData={dynamicMasterData}
                    tabList={tabList}
                    searchList={
                        localStorage.getItem("userTypeId") &&
                            localStorage.getItem("userTypeId") == 3 ?
                            OutletProspectiveStatusJson.searchListForManager :
                            OutletProspectiveStatusJson.searchList
                    }
                    formPath={OutletProspectiveStatusJson.formPath}
                    screenTitle={OutletProspectiveStatusJson.screenTitle}
                    getListById={this.getListById}
                    fieldMeta={OutletProspectiveStatusJson.fieldMeta}
                    showPdfDownload={OutletProspectiveStatusJson.showPdfDownload}
                    showExcelDownload={false}
                    isExcelStaticUrl={false}
                    filterDataExcel={false}
                    pdfFileName={OutletProspectiveStatusJson.pdfFileName}
                    excelFileName={OutletProspectiveStatusJson.excelFileName}
                    showAddButton={false}
                    tableColumnsToFilter={OutletProspectiveStatusJson.tableColumnsToFilter}
                    tableColumns={OutletStatusColumns}
                    tableData={outletList?.outlets}
                    apiBaseURL={OutletProspectiveStatusJson.apiBaseURL}
                    callApi={false}
                    isActiveURL={OutletProspectiveStatusJson.isActiveURL}
                    showAddButtonInTable={true}
                    onClickAdd={this.onClickAdd}
                    openFormPath={OutletProspectiveStatusJson.openFormPath}
                    searchButtonGrid={OutletProspectiveStatusJson.searchButtonGrid}
                    getTableDataById={true}
                    onSearchData={this.onSearchData}
                    getTableData={this.getListData}
                    rowStatusTrue={true}
                    rowStatus={this.onChangeStatus}
                    rowList={dynamicMasterData}
                    staticEdit={false}
                    showHeadDelete={false}
                    showPegination={true}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    areaList: state.area,
    regionList: state.region,
    stateList: state.states,
    zoneList: state.zone,
    districtList: state.district,
    talukaList: state.taluka,
    beatList: state.beat,
    outletList: state.outlet,
});
const mapDispatchToProps = {
    getStateByRegion,
    getZoneByState,
    getTalukaByDistrict,
    getDistrictByZone,
    getAreaByTaluka,
    showLoador,
    showNotification,
    getRegionNew,
    getBeatByAreaIds,
    getOutletByBeatIdsProspectiveStatus,
    setOutletByBeatIds,
    getAreaByUserType,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(OutletStatus);
